// 引入 axios
import axios from "axios";
// import { BASEURL } from '@/api/baseUrl'

axios.defaults.baseURL = process.env.VUE_APP_SERVER


//传送json格式的get请求
export const getRequest = (url, params) => {
	params.sysId = process.env.VUE_APP_SYS_FLAG;	// 系统编号，系统区别
	return request({
		method: 'get',
		url: url,
		params: params,
	});
}

// 封装 POST 方法
export const postRequest = (url, params) => {
	params.sysId = process.env.VUE_APP_SYS_FLAG;	// 系统编号，系统区别 VUE_APP_SYS_FLAG
	return request({
		method: 'post',
		url: url,
		data: params
	});
}

// //传送json格式的get请求
// export const getRequest = async (url, params) => {
// 	  try {
// 	    // 发起GET请求
// 	    const response = await axios.get(`${process.env.VUE_APP_SERVER}${url}`, { params });
// 	    // 请求成功，处理数据（例如：解构，返回特定字段等）
// 	    const { data } = response;
// 	    return data;
// 	  } catch (error) {
// 	    // 请求失败，处理错误
// 	    console.error(`请求出错: ${error}`);
// 	    // 可以返回错误信息或者其他默认值
// 	    return null;
// 	  }
// }


//为了使用方便自定义了一个request请求方法 
export function request(config) {
	// 1.创建axios的实例
	const instance = axios.create({
		// baseURL: "http://127.0.0.1:20011",
		// baseURL: 'http://localhost:18888',
		// baseURL: 'http://43.138.142.170:18888',
		// baseURL: base,
		baseURL: process.env.VUE_APP_SERVER,
		timeout: 10000,
		// 添加数据头为json
		headers: {
		  // 'Content-Type':'application/json',
		  // 'Access-Control-Allow-Origin':'*',
		  // 'Access-Control-Allow-Methods':'POST,GET,OPTIONS, PUT, DELETE',
		}
	});
	
	// 2.1.请求拦截的作用
	instance.interceptors.request.use(config => {
		return config
	}, err => {
		console.log(err);
	});
	
	// 2.2.响应拦截
	instance.interceptors.response.use(res => {
		return res.data
	}, err => {
		console.log(err);
	});
	
	// 3.发送真正的网络请求
	return instance(config)
}
